import axios from 'axios'
import { Message } from 'element-ui'
import login from '@/store/login'
import store from '@/store.js'
import NProgress from 'nprogress'
import utils from '@/eco-ui-util.js'
import 'nprogress/nprogress.css'
import { saveAs } from 'file-saver'
import Formulas from '@/formulas.js'
import { Base64 } from 'js-base64'
import globalUtil from '@/utils'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import tenant from '@/store/tenant'
import router from '@/router'
axios.defaults.timeout = 100000

let pending = [] //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken
let removePending = (ever) => {
  for (let p in pending) {
    if (pending[p].u === ever.url + '&' + ever.method && pending[p].data === eval.data) {
      //当当前请求在数组中存在时执行函数体
      pending[p].f() //执行取消操作
      pending.splice(p, 1) //把这条记录从数组中移除
    }
  }
}

// 请求拦截（配置发送请求的信息）
axios.interceptors.request.use(
  async (config) => {
    // 处理请求之前的配置
    NProgress.start() //开始
    login.state.loadding = true //在请求发出之前进行一些操作
    config.headers = config.headers || {}
    // if (config.headers && config.headers.constructor == String) {
    //   try {
    //     config.headers = JSON.parse(config.headers);
    //   } catch (e) {
    //     Message.error(`请求头部不是有效的JSON格式:${config.headers}`);
    //     throw e;
    //   }
    // }
    // 租户管理登录的用户
    if (sessionStorage.getItem('tenantManager') === 'true') {
      config.headers['X-From'] = 'TENANT-MANAGE'
    } else {
      config.headers['X-From'] = 'IEZU-EVO-PLATFORM'
    }
    config.headers['X-Request-ID'] = Formulas.UUID()
    config.headers['Accept-Language'] = localStorage.getItem('lang') || 'zh-CN'
    // console.info(login.state)
    // if (login.state.loginAccount) {
    //   config.headers["Tenant-Code"] =
    //     localStorage
    //       .getItem(login.state.loginAccount + "loginRoutePath")
    //       .replace("/login/", "") || "";
    // }
    // token
    const tenantId = sessionStorage.getItem('currentTenantId')
    if (tenantId) config.headers['X-Tenant-Id'] = tenantId
    const token = login.state.token
    if (config.url.indexOf('/api/uaa/oauth/token') <= 0 && token) {
      config.headers['Authorization'] = `Bearer ${token}`
    } else {
      if (tenantId) {
        config.headers['Authorization'] = `Basic ` + Base64.encode(tenantId + ':evo!@#$')
      } else {
        // -1 默认租户
        config.headers['Authorization'] = `Basic ` + Base64.encode('-1:evo!@#$')
      }
    }
    if (tenant.state.tenantId && config.url.indexOf('tenantId=') === -1) {
      let joinChar = '?'
      if (config.url.indexOf('?') != -1) {
        joinChar = '&'
      }
      config.url = config.url + joinChar + 'tenantId=' + tenant.state.tenantId
    }
    // 设备信息
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    config.headers['X-Device-ID'] = result.visitorId
    config.headers['X-Device-Info'] = Base64.encode(globalUtil.GetOs() + '|' + globalUtil.GetCurrentBrowser())
    removePending(config) //在一个ajax发送前执行一下取消操作
    config.cancelToken = new cancelToken((c) => {
      // 将请求的地址和请求的方式构建为一个字符串存放到请求数组中
      pending.push({
        u: config.url + '&' + config.method,
        f: c,
        data: config.data
      })
    })
    // if (
    //   config.data &&
    //   config.headers["Content-Type"] === "application/x-www-form-urlencoded"
    // ) {
    //   config.data = qs.stringify(config.data);
    // }
    return config
  },
  (error) => {
    // 请求失败的处理
    NProgress.done() // 结束
    return Promise.reject(error)
  }
)

// 响应拦截（配置请求回来的信息）
axios.interceptors.response.use(
  (res) => {
    // 处理响应数据
    removePending(res.config) //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    if (res.data && res.data.state != undefined && res.data.state === false) {
      Message.error(res.data.message)
    }
    login.state.loadding = false //在这里对返回的数据进行处理
    NProgress.done() // 结束
    // 附件下载
    if (res && res.status == 200 && res.headers && res.headers['content-disposition'] && res.headers['content-disposition'].startsWith('attachment;')) {
      let blob = new Blob([res.data])
      const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
      saveAs(blob, fileName)
    }
    return res
  },
  (error) => {
    // console.dir(error.response);
    // 处理响应失败
    // let loadingInstance = Loading.service({ fullscreen: true }); //开始
    // 退出code
    let loginOutCode = ['20115', '20119', 20119, 20115]
    if (error && error.response && error.response.status === 401) {
      const errResp = error.response
      // 20115 刷新token后仍然失效，登出
      if (errResp.data && errResp.data.numericErrorCode == 20109) {
        return refreshToken(errResp)
      } else if (errResp.data && loginOutCode.indexOf(errResp.data.numericErrorCode) > -1) {
        //退出系统
        router.push({
          name: 'tenantLogin',
          params: {
            tenant: sessionStorage.getItem('tenantCode')
          }
        })
        sessionStorage.clear()
      } else {
        let msg = errResp.data.numericErrorCode ? utils.translateErrMsg(errResp.data.numericErrorCode, errResp.data.errorMessage) : '系统异常，请联系管理员'
        Message.error('[' + errResp.data.numericErrorCode + ']' + msg)
      }
    } else if (error && error.response && error.response.status === 403) {
      let msg = '您没有权限请求此接口'
      if (error.response.data && error.response.data.path) {
        msg += ':' + error.response.data.path
      }
      Message.error(msg + ',请联系管理员')
    } else if (error && error.response && error.response.status === 500) {
      if (error.response.config.url.indexOf('saveForm') == -1) {
        //设计表单页面-控件没有绑定属性，点击保存后会有多个提示
        if (error.response.data && error.response.data.numericErrorCode) {
          let msg = ''
          if (error.response.data.numericErrorCode === 30000) {
            msg = error.response.data.errorMessage ? error.response.data.errorMessage : '系统异常，请联系管理员'
          } else {
            msg = error.response.data.numericErrorCode
              ? utils.translateErrMsg(error.response.data.numericErrorCode, error.response.data.errorMessage)
              : '系统异常，请联系管理员'
          }
          Message.error('[' + error.response.data.numericErrorCode + ']' + msg)
        } else if (error.response.data && error.response.data.message) {
          Message.error(error.response.data.message)
        } else {
          const msg = error.message ? error.message : '系统异常，请联系管理员'
          Message.error(msg)
        }
      }
    } else if (error && error.response && error.response.status === 400) {
      if (error.response.data && error.response.data.numericErrorCode) {
        let msg = ''
        if (error.response.data.numericErrorCode === 30000) {
          msg = error.response.data.errorMessage ? error.response.data.errorMessage : '系统异常，请联系管理员'
        } else {
          msg = error.response.data.numericErrorCode
            ? utils.translateErrMsg(error.response.data.numericErrorCode, error.response.data.errorMessage)
            : '系统异常，请联系管理员'
        }
        Message.error('[' + error.response.data.numericErrorCode + ']' + msg)
      } else if (error.response.data && error.response.data.message) {
        Message.error(error.response.data.message)
      } else {
        const msg = error.message ? error.message : '系统异常，请联系管理员'
        Message.error(msg)
      }
    } else if (error && error.isAxiosError && error.message) {
      Message.error(error.message)
    }
    NProgress.done() // 结束
    // loadingInstance.close(); // 结束
    return Promise.reject(error)
  }
)

// 请求队列
let requestQuery = []
const retryOldRequest = {
  //添加订阅者
  listen(response) {
    return new Promise((resolve) => {
      requestQuery.push((newToken) => {
        let config = response.config || {}
        config.headers['Authorization'] = `Bearer ` + newToken
        resolve(axios(config))
      })
    })
  },

  //发布消息
  trigger(newToken) {
    requestQuery.forEach((fn) => {
      fn(newToken)
    })
    requestQuery = []
  }
}
let isRefreshToken = false
const refreshToken = (response) => {
  if (!isRefreshToken) {
    isRefreshToken = true
    // 刷新token
    let loginRequest = sessionStorage.getItem('loginRequest')
    if (loginRequest) {
      loginRequest = JSON.parse(loginRequest)
      loginRequest.grant_type = 'refresh_token'
      loginRequest.refresh_token = sessionStorage.getItem('refreshToken')
      store
        .dispatch('login/loginByPrincipal', loginRequest)
        .then((resp) => {
          //重试触发
          retryOldRequest.trigger(login.state.token)
        })
        .finally(() => {
          isRefreshToken = false
        })
    }
  }
  //收集订阅者 并把成功后的数据返回原接口
  return retryOldRequest.listen(response)
}

export default {
  request(data) {
    let reqData = data.data || {}
    //支持表达式作为域名解析
    data.url = utils.parseUrl(data.url)
    //统一拼接域名接口
    if (data.url.indexOf('http') == -1) {
      data.url = context.manage + data.url
    }
    let requestData = {
      url: data.url,
      data: reqData,
      method: data.method || 'GET',
      params: data.params || {},
      onUploadProgress: data.onUploadProgress || null,
      headers: data.headers || '',
      responseType: data.responseType || 'json'
    }
    return axios(requestData)
  },
  download(url) {
    return this.request({ url, responseType: 'arraybuffer' })
  },
  downloadTemp(url) {
    return this.request({ url, method: 'POST', responseType: 'arraybuffer' })
  },
  get(url, type = 'json', data) {
    return this.request({ url, data, params: data, responseType: type })
  },
  post(url, data, params, responseType) {
    return this.request({
      url,
      data,
      params,
      method: 'POST',
      responseType: responseType
    })
  },
  remove(url, data) {
    return this.request({ url, data, method: 'DELETE' })
  },
  put(url, data, params, responseType) {
    return this.request({
      url,
      data,
      params,
      method: 'PUT',
      responseType: responseType
    })
  },
  getContext() {
    return context
  },
  formatGetUri(obj) {
    let temp = []
    Object.keys(obj).forEach((key) => {
      let value = obj[key]
      if (typeof value !== 'undefined' || value !== null) {
        temp.push([key, value].join('='))
      }
    })
    return '?' + temp.join('&')
  }
}
